module.exports = __webpack_public_path__ + "static/img/1.f6264a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/medicineAssistant/images/1.png
// module id = 7vSq
// module chunks = 5